export const USER = 'USER';
export const TOGGLE_NAV = 'TOGGLE_NAV';
export const LOG_ACTIVITY = 'LOG_ACTIVITY';
export const CLEAR_LOG = 'CLEAR_LOG';
export const RESET_COUNTER = 'RESET_COUNTER';
